<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      min-width="1050px"
      offset-y
      z-index="12"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          depressed
          :color="btnColor"
          :disabled="btnDisabled"
          dark
          v-bind="attrs"
          v-on="on"
        >
          <v-icon v-if="btnIcon" left small>{{ btnIcon }}</v-icon>
          {{ btnText }}
          <v-icon right small>mdi-menu-down</v-icon>
        </v-btn>
      </template>

      <v-card outlined>
        <v-card-title class="font-weight-medium"
          ><span class="text-subtitle-1 font-weight-medium"
            >{{ title }} auswählen</span
          >
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>

        <v-container>
          <v-row>
            <v-col cols="3">
              <v-card outlined>
                <v-card-subtitle>Vorschläge</v-card-subtitle>
                <v-list dense subheader class="mt-n2">
                  <v-list-item-group v-model="modela" mandatory color="primary">
                    <v-list-item v-for="(item, i) in items" :key="i">
                      <v-list-item-content>
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action-text>{{
                        item.value
                      }}</v-list-item-action-text>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
            <v-col>
              <v-card outlined class="mb-5"
                ><v-card-text
                  ><v-text-field
                    v-model="search"
                    outlined
                    dense
                    label="Relative Zeitangabe"
                    persistent-hint
                    hint="Im Format: 1w, 1m, 1q, 1y"
                    prepend-inner-icon="mdi-filter-variant"
                    class="mr-2"
                    clearable
                  ></v-text-field></v-card-text
              ></v-card>
              <v-card outlined>
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <v-switch label="Startzeitpunkt"></v-switch>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="search"
                        outlined
                        dense
                        label="Von"
                        prepend-inner-icon="mdi-calendar-start"
                        persistent-hint
                        hint="DD.MM.YYYY"
                        class="mr-2"
                        type="date"
                        clearable
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="search"
                        label="Startzeit"
                        hint="HH:MM"
                        persistent-hint
                        outlined
                        dense
                        type="time"
                        prepend-inner-icon="mdi-clock-start"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <v-switch label="Endzeitpunkt"></v-switch>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="search"
                        outlined
                        dense
                        label="Bis"
                        persistent-hint
                        hint="DD.MM.YYYY"
                        prepend-inner-icon="mdi-calendar-end"
                        class="mr-2"
                        type="date"
                        clearable
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="search"
                        label="Startzeit"
                        hint="HH:MM"
                        persistent-hint
                        outlined
                        dense
                        type="time"
                        prepend-inner-icon="mdi-clock-start"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="3"
              ><v-card outlined
                ><v-card-subtitle>Schnellauswahl</v-card-subtitle>
                <v-card-text>
                  <v-container class="pa-0">
                    <v-row align="center" justify="center">
                      <v-col cols="4">
                        <v-btn depressed small class="mr-2"
                          ><v-icon>mdi-chevron-left</v-icon></v-btn
                        >
                      </v-col>
                      <v-col cols="4">
                        <v-btn depressed small>2023</v-btn>
                      </v-col>
                      <v-col cols="4">
                        <v-btn depressed small class="ml-2"
                          ><v-icon>mdi-chevron-right</v-icon></v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-text>
                  <v-container>
                    <v-row align="center" justify="center">
                      <v-col cols="3">
                        <v-btn depressed small>Q1</v-btn>
                      </v-col>
                      <v-col cols="3">
                        <v-btn depressed small>Q2</v-btn>
                      </v-col>
                      <v-col cols="3">
                        <v-btn depressed small>Q3</v-btn>
                      </v-col>
                      <v-col cols="3">
                        <v-btn depressed small>Q4</v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="4">
                        <v-btn depressed small>Jan</v-btn>
                      </v-col>
                      <v-col cols="4">
                        <v-btn depressed small>Feb</v-btn>
                      </v-col>
                      <v-col cols="4">
                        <v-btn depressed small>Mrz</v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4">
                        <v-btn depressed small>Apr</v-btn>
                      </v-col>
                      <v-col cols="4">
                        <v-btn depressed small>Mai</v-btn>
                      </v-col>
                      <v-col cols="4">
                        <v-btn depressed small>Jun</v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4">
                        <v-btn depressed small>Jul</v-btn>
                      </v-col>
                      <v-col cols="4">
                        <v-btn depressed small>Aug</v-btn>
                      </v-col>
                      <v-col cols="4">
                        <v-btn depressed small>Sept</v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4">
                        <v-btn depressed small>Okt</v-btn>
                      </v-col>
                      <v-col cols="4">
                        <v-btn depressed small>Nov</v-btn>
                      </v-col>
                      <v-col cols="4">
                        <v-btn depressed small>Dez</v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text></v-card
              ></v-col
            >
          </v-row>
        </v-container>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close()" small color="primary">Abbrechen</v-btn>
          <v-btn depressed color="primary" @click="apply()" small>
            Anwenden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<style></style>

<script>
export default {
  name: "table-selector-menu",
  props: {
    selection: {},
    title: {
      type: String,
      required: true,
    },
    btnText: {
      type: String,
      required: false,
      default: "Filter",
    },
    btnIcon: {
      type: String,
      required: false,
      default: "",
    },
    btnColor: {
      type: String,
      required: false,
      default: "primary",
    },
    btnDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  model: {
    prop: "selection",
    event: "selectionChange",
  },
  computed: {
    selectionLocal: {
      get: function () {
        return this.selection;
      },
      set: function (value) {
        this.$emit("selectionChange", value);
      },
    },
  },
  data() {
    return {
      menu: false,
      search: "",
      selectionLocalBuffer: [],
      items: [
        {
          text: "Letzte Woche",
          value: "1w",
        },
        {
          text: "Letzter Monat",
          value: "1m",
        },
        {
          text: "Letzte 4 Monate",
          value: "4m",
        },
        {
          text: "Letztes Quartal",
          value: "1q",
        },
        {
          text: "Letztes Kalenderjahr",
          value: "1y",
        },
      ],
      modela: 1,
    };
  },
  methods: {
    close() {
      this.menu = false;
    },
    apply() {
      this.selectionLocal = this.selectionLocalBuffer;
      this.menu = false;
    },
  },
};
</script>
